'use strict';
var userAgent = require('../internals/engine-user-agent');

// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/engine-is-ios.js
// module id = 1192
// module chunks = 0